module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "card__status",
    class: _vm.statusColorClass
  }, [_vm._v("Статус заявки на консультацию: " + _vm._s(_vm.getStatus))]), _c('div', {
    staticClass: "card__body"
  }, [_c('Picture', {
    staticClass: "card__image",
    attrs: {
      "copp": true,
      "src": _vm.items.img && _vm.items.img.small,
      "alt": _vm.items.title
    }
  }), _c('div', {
    staticClass: "card__body__data"
  }, [_c('p', {
    staticClass: "mini bold"
  }, [_vm._v("Заявка на консультацию")]), _c('ConsultationItemBlock', {
    attrs: {
      "header": "Тема обращения"
    }
  }, [_vm._v(_vm._s(_vm.getDataBySpr))]), _c('ConsultationItemBlock', {
    attrs: {
      "header": "Обращение"
    }
  }, [_c('p', {
    staticClass: "mini",
    class: {
      padding_bottom: !!_vm.items.files.length
    }
  }, [_vm._v(_vm._s(_vm.items.appeal))]), (!!_vm.items.files.length) ? _c('div', {
    staticClass: "consult_request_links"
  }, _vm._l((_vm.items.files), function(link, index) {
    return _c('a', {
      class: {
        padding_bottom: index !== _vm.items.files.length - 1
      },
      attrs: {
        "href": link.url.url,
        "download": link.url.name
      }
    }, [_vm._v(_vm._s(link.url.name))])
  }), 0) : _vm._e()]), _c('p', {
    staticClass: "mini"
  }, [_vm._v("Дата подачи: " + _vm._s(_vm.items.date_created))]), (_vm.items.responses.length) ? _c('ConsultationItemBlock', {
    attrs: {
      "header": "Ответ на обращение"
    }
  }, _vm._l((_vm.items.responses), function(requests) {
    return _c('div', {
      key: requests.id,
      staticClass: "consult_request"
    }, [_c('p', {
      staticClass: "mini",
      class: {
        padding_bottom: !!_vm.getLinks(requests.id).length
      }
    }, [_vm._v(_vm._s(requests.response))]), (!!_vm.getLinks(requests.id).length) ? _c('div', {
      staticClass: "consult_request_links"
    }, _vm._l((_vm.getLinks(requests.id)), function(link) {
      return _c('a', {
        attrs: {
          "href": link.url.url,
          "download": link.url.name
        }
      }, [_vm._v(_vm._s(link.url.name))])
    }), 0) : _vm._e()])
  }), 0) : _vm._e(), (_vm.items.state === "inwork") ? _c('p', {
    staticClass: "mini"
  }, [_vm._v("Передано в работу: " + _vm._s(_vm.items.date_updated))]) : _vm._e(), (_vm.items.state === "completed") ? _c('p', {
    staticClass: "mini"
  }, [_vm._v("Дата ответа: " + _vm._s(_vm.items.date_updated))]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ead4727","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/consultations/components/ConsultationItem.vue
// module id = a6dbe3512f7fd24c3b23
// module chunks = 89